import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as gatewayNameListActions from "../actions/gateway_name_list_actions";
import * as gatewayNameListTypes from "../types/gateway_name_list_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getListOfGatewayName(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_GATEWAY_NAME, action.payload);
    if (res.status === 200) {
      yield put(gatewayNameListActions.getListOfGatewayNameSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(gatewayNameListActions.getListOfGatewayNameError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(gatewayNameListActions.getListOfGatewayNameError(e));
  }
}

function* createGatewayName(action) {
  try {
    const res = yield call(api.post, endpoints.SUPER_ADMIN_GATEWAY_NAME, action.payload.data);
    if (res.status === 200) {
      yield put(gatewayNameListActions.createGatewayNameSuccess(res.data));
      yield put(gatewayNameListActions.getListOfGatewayNameRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(gatewayNameListActions.createGatewayNameError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(gatewayNameListActions.createGatewayNameError(e));
  }
}

function* editGatewayName(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_GATEWAY_NAME}/${action.payload.id}`, action.payload.data);
    if (res.status === 200) {
      yield put(gatewayNameListActions.editGatewayNameSuccess(res.data));
      yield put(gatewayNameListActions.getListOfGatewayNameRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(gatewayNameListActions.editGatewayNameError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(gatewayNameListActions.editGatewayNameError(e));
  }
}

function* deleteGatewayName(action) {
  try {
    const res = yield call(api.delete, `${endpoints.SUPER_ADMIN_GATEWAY_NAME}/${action.payload.id}`, action.payload.data);
    if (res.status === 200) {
      yield put(gatewayNameListActions.deleteGatewayNameSuccess(res.data));
      yield put(gatewayNameListActions.getListOfGatewayNameRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(gatewayNameListActions.deleteGatewayNameError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(gatewayNameListActions.deleteGatewayNameError(e));
  }
}

export default function* gatewayNameListSaga() {
  yield takeLatest(gatewayNameListTypes.getListOfGatewayName.GET_LIST_OF_GATEWAY_NAME_REQUEST, getListOfGatewayName);
  yield takeLatest(gatewayNameListTypes.createGatewayName.CREATE_GATEWAY_NAME_REQUEST, createGatewayName);
  yield takeLatest(gatewayNameListTypes.editGatewayName.EDIT_GATEWAY_NAME_REQUEST, editGatewayName);
  yield takeLatest(gatewayNameListTypes.deleteGatewayName.DELETE_GATEWAY_NAME_REQUEST, deleteGatewayName);
}
